import {cascadeMap} from '../services'
import {fetch as fetchRaw} from '@lib/fetch'
import {getDefinedUrlSearchParams} from '@lib/util'

const fetch = (url, ...args) => fetchRaw([cascadeMap.url, url], ...args)

export function getCompanyChainList(queryParams) {
  return fetch(`/v1/company-chains/collaborations?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function patchMappingDepth(collaborationId, body) {
  return fetch(`/v1/company-chains/collaborations/${collaborationId}/mapping-depth`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function supplyChainsBulkArchive(body) {
  return fetch(`/v1/company-chains/bulk-archive`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function supplyChainsBulkUnArchive(body) {
  return fetch(`/v1/company-chains/bulk-unarchive`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getCompanyChain(collaborationId) {
  return fetch(`/v1/company-chains/collaborations/${collaborationId}`, {
    method: 'GET',
  })
}

export function getFullCompanyChain(collaborationId) {
  return fetch(`/v1/company-chains/collaborations/${collaborationId}/expand-all`, {
    method: 'GET',
  })
}

export function companySupplyChainCreate(body) {
  return fetch(`/v1/company-chains`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function companiesLinkIntoSupplyChain(collaborationId, body) {
  return fetch(`/v1/company-chains/collaborations/${collaborationId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function companiesUnMapped(nodeId, queryParams) {
  return fetch(
    `/v1/company-chains/nodes/${nodeId}/unmapped-company-profiles?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    }
  )
}

export function supplyChainsBulkExport(body) {
  return fetch(`/v1/company-chains/export`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getCompanyChainExpandNodes(nodeId, queryParams) {
  return fetch(`/v1/company-chains/nodes/${nodeId}/expand?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function supplyChainsDuplicate(collaborationId) {
  return fetch(`/v1/company-chains/${collaborationId}/duplicate`, {
    method: 'POST',
  })
}

export function inviteCollaborators(body) {
  return fetch(`/v1/supply-chain-collaborators`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function acceptCollaboration(collaborationId) {
  return fetch(`/v1/company-chains/collaborations/${collaborationId}/accept`, {
    method: 'PATCH',
    body: JSON.stringify({}),
  })
}

export function patchExistingSupplyChain(body) {
  return fetch('/v1/company-chains/reuse', {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

// is there use of it anywhere?
export function getSupplyChainCompaniesList(companyChainId, queryParams) {
  return fetch(`/v1/company-chains/${companyChainId}/companies?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function invitationReminder(collaborationId, body) {
  return fetch(`/v1/company-chains/collaborations/${collaborationId}/invitation-reminders`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function updateNodeFacilityProcess(nodeId, body) {
  return fetch(`/v1/company-chains/nodes/${nodeId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function getSupplyChainSingleNode(nodeId) {
  return fetch(`/v1/company-chains/nodes/${nodeId}`, {
    method: 'GET',
  })
}

export function getSupplyChainUpstreamNodesByNodeId(nodeId) {
  return fetch(`/v1/company-chains/nodes/${nodeId}/descedants`, {
    method: 'GET',
  })
}

export function deleteSupplyChainNodeWithUpstreamConnections(nodeId) {
  return fetch(`/v1/company-chains/nodes/${nodeId}`, {
    method: 'DELETE',
  })
}

export function updateSupplyChainMetadata(collaborationId, body) {
  return fetch(`/v1/company-chains/collaborations/${collaborationId}/metadata`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function replaceSupplyChainNode(nodeId, body) {
  return fetch(`/v1/company-chains/nodes/${nodeId}/replace`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function getCollaborationMapDetails(id) {
  return fetch(`/v1/company-chains/collaborations/${id}/map`, {
    method: 'GET',
  })
}

export function getSupplierStatistics() {
  return fetch(`/v1/supplier-statistics/`, {
    method: 'GET',
  })
}

export function updateSupplyChainStatus(collaborationId, body) {
  return fetch(`/v1/company-chains/collaborations/${collaborationId}/status`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function getMappedCompaniesList(queryParams) {
  return fetch(`/v1/company-profiles/company-chains/mapped-companies?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getSingleSupplierDetails(companyId) {
  return fetch(`/v1/company-chains/insights/suppliers/${companyId}`, {
    method: 'GET',
  })
}
export function getGlobalSupplyChainBoardData() {
  return fetch(`/v1/company-chains/insights/global-diagram/`, {
    method: 'GET',
  })
}

export function getHistories(queryParams) {
  return fetch(`/v1/company-chains/history?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getCollaboratorsList(queryParams) {
  return fetch(`/v1/company-chains/collaborators?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getCriticalSuppliersList() {
  return fetch(`/v1/supplier-statistics/critical-suppliers`, {
    method: 'GET',
  })
}

export function getFacilityProcessOverview() {
  return fetch(`/v1/supplier-statistics/facility-process-overview`, {
    method: 'GET',
  })
}
